import jQuery from 'jquery';

const tabs = {
    init: () => {
        const productTabsHeaders = document.querySelectorAll('.single-product__tabs-header');
        const productTabsDescriptions = document.querySelectorAll('.single-product__tabs-description');

        if (productTabsHeaders.length != 0) {

            productTabsHeaders[0].classList.add('single-product__tabs-header--active');
            productTabsDescriptions[0].classList.add('single-product__tabs-description--active');
    
            let activeIndex = 0;
    
            const handleTabChange = (target, index) => {
                if (index !== activeIndex) {
                    jQuery(productTabsDescriptions[activeIndex]).slideUp();
                    jQuery(productTabsDescriptions[index]).slideDown();
    
                    productTabsHeaders[activeIndex].classList.remove('single-product__tabs-header--active');
                    productTabsDescriptions[activeIndex].classList.remove('single-product__tabs-description--active');
    
                    activeIndex = index;
    
                    productTabsHeaders[index].classList.add('single-product__tabs-header--active');
                    productTabsDescriptions[index].classList.add('single-product__tabs-description--active');
                }
            }
    
            productTabsHeaders.forEach((header, index) => {
                if (index !== 0) {
                    jQuery(productTabsDescriptions[index]).slideUp(0);
                }
                header.addEventListener('click', target => {
                    handleTabChange(target, index);
                });
            });
        }
    }
}

export default tabs;